module.exports = __webpack_public_path__ + "img/1451688828.983c5778.jpg";